import Tag from '../../Atoms/Tag';
import Img from '../../Atoms/Image';
import Title from '../../Atoms/Title';
import Text from '../../Atoms/Text';
import { Props as CardVacancyProps } from '../../Molecules/CardVacancy';
import TextContent from '../../Molecules/TextContent';
import UserInfo from '../../Molecules/UserInfo';
import SocialBar from '../../Molecules/SocialBar';
import CardVacancyCarousel from '../../Organisms/CardVacancyCarousel';

import cardImg1 from '../../../assets/img/card-image01.png';
import blogPostImage1 from '../../../assets/img/blog-post-image01.webp';
import blogPostImage2 from '../../../assets/img/blog-post-image02.webp';

import vacancyList from '../../../data/vacancyListData';

function BlogPost() {
  return (
    <div>
      <div className="flex flex-col items-center justify-between px-7 pt-20 pb-10">
        <div className="mx-auto flex w-full max-w-4xl flex-col gap-5 lg:px-12">
          <Title as="h1" size={2}>
            Afgestudeerd in Werktuigbouwkunde? Welke banen
            zijn er voor jou?
          </Title>

          <Text as="div" className="flex flex-col gap-5">
            <p>
              Bijna alles om je heen heeft een link met
              werktuigbouwkunde. In dit brede, technische
              vakgebied zijn dan ook veel mogelijkheden. Met
              een diploma Werktuigbouwkunde heb je een
              vooruitzicht op toffe banen en een goed
              salaris. In deze blog leggen we je alles uit
              over Werktuigbouwkunde, banen en het salaris.
            </p>
            <p>
              Lorem ipsum dolor sit amet consectetur
              adipisicing elit. Perspiciatis dolorum quia
              corrupti consequatur iusto laborum ut earum
              voluptate necessitatibus eveniet repellat,
              recusandae itaque. Iste itaque assumenda
              sapiente necessitatibus dolorem unde.
            </p>
          </Text>

          <div className="flex w-full flex-wrap gap-x-14 gap-y-5 pt-14 text-sm text-sl-blue-dark md:text-base lg:text-lg">
            <UserInfo
              img={{
                src: cardImg1,
                alt: 'Claudine Photo'
              }}
              text="Claudine"
            />

            <div className="flex items-center gap-2 text-sl-gray">
              <Tag
                text="2 minutes"
                icon="clock"
                className="gap-x-2.5"
              />
            </div>
          </div>

          <div className="-mx-7 py-14 md:-mx-0 md:py-20">
            <Img
              src={blogPostImage1}
              alt="Blog post image 1"
              className="w-full rounded-xl object-cover object-center"
            />
          </div>
        </div>
        <div className="mx-auto flex w-full max-w-3xl flex-col gap-5 text-sl-blue lg:px-0">
          <TextContent>
            <h2>Wat is Werktuigbouwkunde?</h2>
            <p>
              Werktuigbouwkunde is een technische studie
              waarbij je leert hoe je machines en
              installaties ontwerpt, bouwt en onderhoudt.
              <a href="#!">
                Denk hierbij aan machines in de industrie,
                installaties in gebouwen en machines in de
                landbouw. Werktuigbouwkunde
              </a>{' '}
              is een brede studie, waarbij je veel kennis
              opdoet over verschillende vakgebieden. Je
              leert bijvoorbeeld over werktuigbouwkunde,
              elektrotechniek, besturingstechniek,
              mechanica, werktuigbouw, afgestudeerd bent in
              de Werktuigbouwkunde, dan kun je rekenen op
              een zeer hoge baangarantie. Op dit moment is
              er een grote vraag naar Werktuigbouwkundigen
              en door de grote schaarste staan er veel
              vacatures open. Voor jou betekent dit een
              ruime keuze in branches, banen én werkgevers.
              Daarnaast kun je als afgestudeerde in
              Werktuigbouwkunde rekenen op een hoog salaris.
            </p>
            <p>
              Als je afgestudeerd bent in de
              Werktuigbouwkunde, dan kun je rekenen op een
              zeer hoge baangarantie. Op dit moment is er
              een grote vraag naar Werktuigbouwkundigen en
              door de grote schaarste staan er veel
              vacatures open. Voor jou betekent dit een
              ruime keuze in branches, banen én werkgevers.
              Daarnaast kun je als afgestudeerde in
              Werktuigbouwkunde rekenen op een hoog salaris.
            </p>
            <p>&nbsp;</p>
            <h3>
              Deze banen zijn er in de Werktuigbouwkunde
            </h3>
            <p>
              Als afgestudeerde Werktuigbouwkunde kun je bij
              veel bedrijven aan de slag uit verschillende
              branches en industrieën. Er zijn veel
              openstaande vacatures voor jou als
              afgestudeerde Werktuigbouwkunde. Hieronder een
              selectie van een aantal vacatures:
            </p>
            <p>&nbsp;</p>

            <h4>
              Deze banen zijn er in de Werktuigbouwkunde
            </h4>
            <p>
              <u>Mechanical Engineer</u>
            </p>
            <p>
              Als Mechanical Engineer ga je aan de slag met
              het ontwerpen en bedenken van producten,
              processen en systemen. Daarnaast analyseer je
              en breng je verbeteringen aan. Als Mechanical
              Engineer kun je in verschillende toffe
              branches aan de slag: machinebouw,
              (proces)industrie en industriële
              automatisering.
            </p>

            <p>&nbsp;</p>

            <h5>
              Deze banen zijn er in de Werktuigbouwkunde
            </h5>
            <p>
              <u>Project Engineer</u>
            </p>
            <p>
              In de functie van Project Engineer ben je van
              A tot Z betrokken bij een project. Als Project
              Engineer ben je onder andere verantwoordelijk
              voor het bedenken en verbeteren van nieuwe en
              bestaande machines. Je werkt samen met
              collega’s van verschillende afdelingen en je
              hebt waar nodig contact met klanten. Op deze
              manier creëer je een zo goed mogelijke
              oplossing voor alle partijen en houd jij het
              overzicht.
            </p>
            <p>
              <u>R&D Engineer</u>
            </p>
            <p>
              In de rol van R&D Engineer ben je
              verantwoordelijk voor het traject van de
              conceptfase van een machine en installatie,
              tot en met de inbedrijfstelling van de
              producten/processen. Als R&D Engineer houd je
              je bezig met de verbetering en
              doorontwikkeling van machines, systemen en
              nieuwe producten. Dit doe je door
              marktonderzoek te doen en goed naar de wensen
              en behoeften van klanten te luisteren.
            </p>
            <p>
              <u>Design Engineer</u>
            </p>
            <p>
              Als Design Engineer ontwerp je samen met
              collega Engineers hoog geautomatiseerde
              machines en installaties naar de wens van de
              klant. Hierbij ga je aan de slag met
              construeren, berekenen en het in kaart brengen
              van risico’s met nauwkeurige analyses. Jij
              bent verantwoordelijk voor de realisatie van
              de projecten.
            </p>
            <Img
              src={blogPostImage2}
              alt="Blog post image 2"
            />

            <p>
              Als Design Engineer ontwerp je samen met
              collega Engineers hoog geautomatiseerde
              machines en installaties naar de wens van de
              klant. Hierbij ga je aan de slag met
              construeren, berekenen en het in kaart brengen
              van risico’s met nauwkeurige analyses. Jij
              bent verantwoordelijk voor de realisatie van
              de projecten.
            </p>

            <ul>
              <li>
                Mechanical Engineer: salaris tussen €2400 en
                €3100
              </li>
              <li>
                Project Engineer: salaris tussen €2500 en
                €3200
              </li>
              <li>
                Design Engineer: salaris tussen €2600 en
                €3300
              </li>
              <li>
                R&D Engineer: salaris tussen €2200 en €3100
              </li>
            </ul>

            <ol>
              <li>
                Mechanical Engineer: salaris tussen €2400 en
                €3100
              </li>
              <li>
                Project Engineer: salaris tussen €2500 en
                €3200
              </li>
              <li>
                Design Engineer: salaris tussen €2600 en
                €3300
              </li>
              <li>
                R&D Engineer: salaris tussen €2200 en €3100
              </li>
            </ol>

            <blockquote>
              <p>
                “In simple, to degree perfecting that six
                the impact or a with to seen, all are,
                systems seven his they equally to privilege
                now”
              </p>
              <cite>Peter-Jan Kloppers</cite>
            </blockquote>
          </TextContent>
        </div>
      </div>

      <div className="flex flex-col px-7 py-10">
        <Title as="h2" size={3} className="text-center">
          Gerelateerde vacatures
        </Title>
        <CardVacancyCarousel
          vacancyList={vacancyList as CardVacancyProps[]}
        />
      </div>

      <div className="flex flex-col items-center justify-between px-7 py-10">
        <div className="flex flex-col items-center gap-7 sm:flex-row">
          <span className="text-[10px] uppercase">
            Deel dit artikel
          </span>
          <SocialBar
            className="justify-center sm:justify-start"
            rounded
            socialItems={[
              {
                icon: 'facebook',
                url: '#!'
              },
              {
                icon: 'mail',
                urlType: 'mail',
                url: '#!'
              },
              {
                icon: 'whatsapp',
                url: '#!'
              },
              {
                icon: 'linkedin',
                url: '#!'
              }
            ]}
          />
        </div>
      </div>
    </div>
  );
}

export default BlogPost;
